export default {
  data() {
    return {
      countLoading: 0
    };
  },
  methods: {
    showLoading() {
      this.countLoading++;
      if (this.countLoading > 0) {
        this.$store.dispatch('SHOWLOADING', true);
      }
    },
    hideLoading() {
      this.countLoading = this.countLoading > 0 ? this.countLoading - 1 : 0;
      if (this.countLoading === 0) {
        setTimeout(() => {
          this.$store.dispatch('SHOWLOADING', false);
        }, 100);
      }
    }
  }
};
